import { render, staticRenderFns } from "./StickerPurchasePage.vue?vue&type=template&id=79b23e49&scoped=true&"
import script from "./StickerPurchasePage.vue?vue&type=script&lang=ts&"
export * from "./StickerPurchasePage.vue?vue&type=script&lang=ts&"
import style0 from "./StickerPurchasePage.vue?vue&type=style&index=0&id=79b23e49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b23e49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
